import { useState } from 'react';
import { useApp } from '../AppContext';
import './Onboard.css';

const FULL_HADITH = `Anas ibn Malik reported: He was sitting with the Messenger of Allah ﷺ and he said, "Coming upon you now is a man from the people of Paradise." So a man came from the helpers whose beard looked disarrayed by the water from ablution, and he was carrying both of his shoes with his left hand.

The next day the Prophet repeated the same words, and the helpers came in the same condition. The third day the Prophet repeated the same again.

Abdullah ibn Umar ibn Al-As followed the man and stayed with him three nights but never saw him praying at night. Whenever he went to bed, he would remember Allah and rest. Abdullah never heard anything but good from his mouth.

After three nights, Abdullah asked: "O servant of Allah — the Messenger of Allah said three times that a man from the people of Paradise was coming, and then you came. But I did not see you do anything special. What is the reason?"

The man said: "It is as you have seen, except that I do not find fraud in my soul towards the Muslims, and I do not envy anyone because of the good that Allah has given them."

— Musnad Ahmad 12286, Sahih`;

export default function Onboard() {
  const { setScreen, setAuthMode } = useApp();
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="onboard">
      <div className="ob-crescent float-anim">☽</div>
      <div className="ob-bismillah">بِسْمِ اللَّهِ</div>
      <div className="ob-logo">Mercy</div>
      <div className="ob-tagline">Forgive before you sleep.</div>

      {/* Primary hadith — Anas ibn Malik */}
      <div className="hadith-card">
        <div className="hadith-quote">"</div>
        <div className="hadith-text">
          "I do not find fraud in my soul towards the Muslims, and I do not envy
          anyone because of the good that Allah has given them."
        </div>
        <div className="hadith-source">A man of Paradise · Musnad Ahmad 12286 · Sahih</div>
        <button className="hadith-expand-btn" onClick={() => setExpanded(v => !v)}>
          {expanded ? 'Hide full story ↑' : 'Read the full story ↓'}
        </button>
        {expanded && (
          <div className="hadith-full">
            {FULL_HADITH.split('\n\n').map((para, i) => (
              <p key={i}>{para}</p>
            ))}
          </div>
        )}
      </div>

      <ul className="ob-steps">
        <li><span className="ob-dot" />Keep your heart clean of malice and envy</li>
        <li><span className="ob-dot" />Forgive everyone each night with one tap</li>
        <li><span className="ob-dot" />Your circle will know you did</li>
      </ul>

      <button className="btn btn-primary" onClick={() => { setAuthMode('signup'); setScreen('auth'); }}>
        Begin
      </button>
      <button className="btn btn-secondary" style={{ marginTop: 10 }} onClick={() => { setAuthMode('login'); setScreen('auth'); }}>
        I already have an account
      </button>
    </div>
  );
}
